/**
 * PagesProvider
 * Contain most logic handing with Omnitech Api
 */


import React from 'react'
import PagesContext from './pages-context'
import { fetchPage } from './pages-api'

export default function PagesProvider({ children }) {
  const state = {
    fetchPage
  }

  return (
    <PagesContext.Provider value={state}>
      {children}
    </PagesContext.Provider>
  )
};
